import { Button, Input, message, Modal, Spin } from "antd";
import styles from "./styles.module.scss";
import { ModalCloseIcon } from "icons";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { useState } from "react";
import { ConditionalRenderer } from "components";
import { UseLazyApiCallV2 } from "hooks";
import { useCurrentUserContext } from "providers";

export function AddNewColumnStatus({
  open,
  onClose,
  refetchColumnsStatus,
  refetchCases,
}) {
  const { translator } = useLanguageTranslator();
  const [statusName, setStatusName] = useState();
  const [error, setError] = useState(false);
  const { user } = useCurrentUserContext();

  const [createNewStatusColumn, { isLoading: createNewStatusColumnLoading }] =
    UseLazyApiCallV2({
      url: "/create_status",
      method: "POST",
    });

  async function onConfirm(e) {
    e.preventDefault();
    if (!statusName) {
      return setError(true);
    }
    try {
      const res = await createNewStatusColumn({
        params: {
          statusName,
          loggedUser: user?.email,
        },
      });

      if (res?.status === "Success") {
        message.success(`${statusName} created Successfully.`);
        const existing = JSON.parse(localStorage.getItem("statusColumnsOrder"));
        console.log({ existing, statusName });

        const newOnes = [...existing, statusName];

        localStorage.setItem("statusColumnsOrder", JSON.stringify(newOnes));
        const newItems = JSON.parse(localStorage.getItem("statusColumnsOrder"));
        console.log({ newItems });

        setInitialDataAndCloseModal();
        refetchColumnsStatus();
        refetchCases();
      } else if (res?.status === "Error") {
        message.error(res?.message);
      }
    } catch (error) {}
  }

  function setInitialDataAndCloseModal() {
    setStatusName("");
    setError(false);
    onClose();
  }

  return (
    <>
      <Modal
        destroyOnClose
        className={styles.logoutModal}
        closeIcon={<ModalCloseIcon />}
        title={translator("addCategory")}
        open={open}
        cancelText="No"
        centered={true}
        okText="Yes"
        width={792}
        footer={null}
        onCancel={setInitialDataAndCloseModal}
      >
        <Spin spinning={createNewStatusColumnLoading}>
          <form onSubmit={onConfirm}>
            <div className={styles.label}>
              {translator("enterCategoryName")} <span>*</span>
            </div>
            <Input
              status={error ? "error" : ""}
              value={statusName}
              onChange={(e) => setStatusName(e.target.value)}
              placeholder={translator("categoryName")}
              style={{ width: "100%", height: "43px" }}
              required
            />
            <ConditionalRenderer condition={error && !statusName}>
              <div className={styles.requiredLabel}>
                {translator("required")}
              </div>
            </ConditionalRenderer>
            <div className={`${styles.flex}`}>
              <Button
                className={styles.modalNoButton}
                onClick={setInitialDataAndCloseModal}
              >
                {translator("cancel")}
              </Button>
              <Button
                className={styles.modalYesButton}
                type="primary"
                htmlType="submit"
                onClick={onConfirm}
              >
                {translator("done")}
              </Button>
            </div>
          </form>
        </Spin>
      </Modal>
    </>
  );
}
